import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore, collection, doc, setDoc, getDocs, updateDoc, deleteDoc, query, orderBy } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import firebaseConfig from "../../firebase-applet-config.json";

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const appId = firebaseConfig.projectId || 'armellini-crm-f0beb';

// Setup Google Auth Provider with all requested Workspace Scopes
export const googleProvider = new GoogleAuthProvider();

// Scopes required for requested Google integrations
const SCOPES = [
  "https://www.googleapis.com/auth/userinfo.email",
  "https://www.googleapis.com/auth/userinfo.profile",
  "https://www.googleapis.com/auth/drive.file",
  "https://www.googleapis.com/auth/drive.metadata.readonly",
  "https://www.googleapis.com/auth/spreadsheets",
  "https://www.googleapis.com/auth/gmail.send",
  "https://www.googleapis.com/auth/gmail.modify",
  "https://www.googleapis.com/auth/gmail.readonly",
  "https://www.googleapis.com/auth/calendar",
  "https://www.googleapis.com/auth/chat.spaces",
  "https://www.googleapis.com/auth/chat.messages.create",
  "https://www.googleapis.com/auth/contacts",
  // Read the Workspace user directory (admin accounts only) so admins can
  // import teammates into the CRM from Settings > User Access Control.
  "https://www.googleapis.com/auth/admin.directory.user.readonly"
];

SCOPES.forEach(scope => {
  googleProvider.addScope(scope);
});

// Prompt with select_account for seamless 1-click reconnect without re-approving permissions.
// `hd` restricts the account chooser to the Armellini Workspace domain; the
// server independently rejects out-of-domain tokens, since hd is only a hint.
googleProvider.setCustomParameters({
  prompt: 'select_account',
  access_type: 'offline',
  hd: 'armellini.com'
});

export { app };
